import { ChallengesService } from '../../challenges.service';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GridApi, GridOptions } from 'ag-grid-community';
import { LeaderboardRankingItem } from '../../challenge.model';

@Component({
	selector: 'cv-cxone-challenge-leaderboard-modal',
	templateUrl: './cxone-challenge-leaderboard-modal.component.html',
	styleUrl: './cxone-challenge-leaderboard-modal.component.scss'
})
export class CxoneChallengeLeaderboardModalComponent implements OnInit {

	rankings: LeaderboardRankingItem[] = [];
	headerTitle: string = this.dialogConfig.data.headerTitle;
	closeLabel: string = this.dialogConfig.data.closeLabel;
	metricName: string = this.dialogConfig.data.metricName;
	getLocalizationString: (key: string, defaultValue: string) => string = this.dialogConfig.data.getLocalizationString;
	gridOptions: GridOptions = null;
	currentUserName: any = null;
	gridApi: GridApi;
	private readonly NODATA = "N/A";

	constructor(
		private dialogConfig: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private challengeService: ChallengesService
	) { }

	async ngOnInit() {
		await this.loadCurrentUser();
		this.loadRankings();
		this.setupGrid();
	}

	async loadCurrentUser() {
		this.currentUserName = await this.challengeService.getCurrentUser();
	}

	loadRankings() {
		const currentRankingdUser: LeaderboardRankingItem = this.dialogConfig.data.rankings
			.find((ranking: LeaderboardRankingItem) => ranking.Name === this.getLocalizationString("Me", "Me") || ranking.Name === this.currentUserName);
		
		const rankingList = this.dialogConfig.data.rankings
			.filter((ranking: LeaderboardRankingItem) => ranking.Name !== this.getLocalizationString("Me", "Me") && ranking.Name !== this.currentUserName)
			.sort((a: LeaderboardRankingItem, b: LeaderboardRankingItem) => (a.ViewScore === null ? 1 : (b.ViewScore === null ? -1 : 0)))
			.map((ranking: LeaderboardRankingItem) => this.noRankingUser(ranking));
		
		if(currentRankingdUser) {
			const user = this.noRankingUser({...currentRankingdUser});
			user.Name = this.currentUserName;
			user.ViewScore = user.ViewScore || this.NODATA;
			this.rankings.push(user);
		}

		const rankingResults = [...this.rankings, ...rankingList];
		const checkEmptyMetric = (ranking: LeaderboardRankingItem) => ranking.ViewScore === this.NODATA || ranking.ViewScore === '0' || ranking.ViewScore == '00:00:00' ||
		ranking.ViewScore === '0%' || ranking.ViewScore === '0.00%';
		const isEmptyMetric = rankingResults.every(checkEmptyMetric);
		this.rankings = isEmptyMetric ? rankingResults.map((ranking: LeaderboardRankingItem) => { return {...ranking, ViewPlace: this.NODATA} }) : rankingResults;
	}

	onDismiss() {
		this.dialogRef.close();
	}

	onClose() {
		this.dialogRef.close();
	}

	manageNoRowsOverlay() {
		if (this.gridApi.getDisplayedRowCount() === 0) {
			this.gridApi.showNoRowsOverlay();
		}
		else {
			this.gridApi.hideOverlay();
		}
	}
	
	selectCurrentUserRow() {
		this.gridApi.forEachNode((node, index) => {
			const rowData = node.data;
			if(index === 0 && rowData.Name === this.currentUserName) {
				node.setSelected(true);
			}
		})
	}

	noRankingUser(ranking: LeaderboardRankingItem): LeaderboardRankingItem {
        return {
            ...ranking,
            ViewPlace: ranking.ViewScore ? `${ranking.Place}` : this.NODATA,
            ViewScore: ranking.ViewScore || this.NODATA
        }
    }

	setupGrid() {
		this.gridOptions = {
			suppressDragLeaveHidesColumns: true,
			suppressRowGroupHidesColumns: true,
			suppressContextMenu: true,
			suppressCellFocus: true,
			rowHeight: 36,
			headerHeight: 44,
			suppressPreventDefaultOnMouseWheel: true,
			suppressHorizontalScroll: true,
			enableBrowserTooltips: false,
			overlayNoRowsTemplate: `<div class="error-container">
                                        <svg class="cxoneFavoriteState mb-2" style="width: 240px !important;height:108px !important;">
                                            <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
                                        </svg>
                                        <p class="cxone-error-text">${this.getLocalizationString("No_Leaderboard_Found", "No one has accepted this challenge yet.")}</p>
                                    </div>`,
			rowData: this.rankings,
			columnDefs: [
				{
					headerName: this.getLocalizationString("Rank_Title", "Rank"),
					field: 'ViewPlace',
					sortable: false,
				},
				{
					headerName: this.getLocalizationString("Participant", "Participant"),
					field: 'Name',
					sortable: false,
				},
				{
					headerName: this.metricName,
					field: 'ViewScore',
					sortable: false,
				}
			],
			defaultColDef: {
                resizable: false,
				suppressMenu: true,
            },
			onGridSizeChanged(event) {
				event.api.sizeColumnsToFit();
			},
			onGridReady: (event) => {
				this.gridApi = event.api;
				this.manageNoRowsOverlay();
                event.api.sizeColumnsToFit();
				this.selectCurrentUserRow();
			},
		}
	}
}
